import '@fontsource/barlow/400.css'
import '@fontsource/barlow/500.css'
import '@fontsource/barlow/600.css'
import '@fontsource/barlow/700.css'
import '@fontsource/barlow-condensed/400.css'
import '@fontsource/barlow-condensed/500.css'
import '@fontsource/barlow-condensed/600.css'
import '@fontsource/barlow-condensed/700.css'
import '@fontsource/barlow-condensed/800.css'

import '@css/main.scss'
import '@js/bootstrap'

import {Header} from '@js/components/Header'
import {Slider} from '@js/components/Slider'
import {Archive} from '@js/components/Archive'
import {Roster} from '@js/components/Roster'
import {Timeline} from '@js/components/Timeline'
import {MatchBoard} from '@js/components/MatchBoard'
import {Lightbox} from '@js/components/Lightbox'
import {Mask} from '@js/animations/Mask'
import {Stagger} from '@js/animations/Stagger'
import {Wipe} from '@js/animations/Wipe'
import {Scroll} from '@js/animations/Scroll'
import {Translate} from '@js/animations/Translate'
import {Shape} from '@js/animations/Shape'
import {Zoom} from '@js/animations/Zoom'

const animations = [
  Mask,
  Stagger,
  Wipe,
  Scroll,
  Translate,
  Shape,
  Zoom,
]

const bootAnimations = () => {
  animations.forEach((animation) => {
    new animation()
  })
}

const bootComponents = () => {
  new Header()
  new Archive()
  new Slider()
  new Roster()
  new Timeline()
  new MatchBoard()
  new Lightbox()
}

// ponytail: animations au DOMContentLoaded — window.onload attend les images → flash visible/caché
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootAnimations)
} else {
  bootAnimations()
}

window.onload = bootComponents
